import React, { useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { login } from '../store/loginReducer';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SigninForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let apiUrl = '/';

  if(process.env.REACT_APP_ENVIRONMENT == 'local'){
       apiUrl = process.env.REACT_APP_SERVER_API_URL;
  }

  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await axios.post(`${apiUrl}api/users/signin`, formData);

      if (response.status === 200) {
        const userdata = {
          id: response.data.user._id,
          name: response.data.user.name,
          email: response.data.user.email,
          type: response.data.user.type,
        };

        dispatch(login(userdata));
        navigate('/');
      }
      else{
        toast.error("Invalid credentials");
      }
    } catch (error) {
      toast.error("Invalid credentials");
      console.error('Error signing in:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="signin-section" style={{ marginTop: "20px" }}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 d-none d-lg-block">
            <img
              src="../assets/img/signin.jpg"
              alt="Signin Illustration"
              className="img-fluid rounded"
              style={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)" }}
            />
          </div>

          {/* Right Side: Form */}
          <div className="col-lg-6">
            <div className="form-card p-4 shadow rounded bg-white">
              <h2 className="text-center mb-4">Welcome Back</h2>
              <p className="text-center text-muted mb-4">
                Please sign in to continue.
              </p>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Email"
                    name="email"
                    id="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Password"
                    name="password"
                    id="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={isLoading}
                >
                  {isLoading ? "Signing In..." : "Sign In"}
                </button>
                <p className="text-center mt-3">
                  Don't have an account?{" "}
                  <Link to="/account/signup">Sign Up</Link>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SigninForm;
